import React from "react";
import { Field } from "react-final-form"; 
import ToggleButtonAdapter from "../userAdapters/ToggleButtonAdapter";

const QuestionFieldToggle = (props) => {
  let { required, name, label } = props;

  if (required === undefined) {
    required = false;
  }

  return (
    <Field
      name={name}
      required={required}
      label={label}
      autoComplete=""
      component={ToggleButtonAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: 10 }}
      multiline={true}
    />
  );
};

export default QuestionFieldToggle;
